"use client";

import { Popover } from "@focal/ui-kit";

import { useState } from "react";
import { cn } from "@/lib/utils";
import { Client, Participant, User, SuggestedParticipants } from "@/types";
import { ConversationPersonCard } from "@/components/pages/Conversations/ConversationsDetails/ConversationPersonTag/ConversationPersonCard";
import {
  ConversationPersonPopoverPaginated,
  UpdateParticipantData,
} from "@/components/pages/Conversations/ConversationsDetails/ConversationPersonTag/ConversationPersonPopoverPaginated";

interface ConversationPersonTagProps {
  participant?: Partial<Participant>;
  clients?: Client[];
  users?: User[];
  onSelectParticipant: (data: UpdateParticipantData) => void;
  onDeleteParticipant?: (participantId: string) => void;
  disableRedirect?: boolean;
  disableRemove?: boolean;
  disableUsers?: boolean;
  isLoading?: boolean;
  participants?: Partial<Participant>[];
  suggestedParticipants?: SuggestedParticipants;
  showAssignmentStatus?: boolean;
  className?: string;
}

export const ConversationPersonTag = ({
  participant,
  onSelectParticipant,
  onDeleteParticipant,
  disableRedirect,
  disableRemove,
  disableUsers,
  isLoading,
  participants = [],
  suggestedParticipants,
  showAssignmentStatus,
  className,
}: ConversationPersonTagProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Popover open={open} onOpenChange={setOpen} modal>
        <div
          className={cn(
            "flex items-center m-0 relative group overflow-hidden rounded-xl hover:bg-blue-50 transition-colors",
            className,
          )}
          data-cy="participant-tag"
        >
          <ConversationPersonCard
            onDeleteParticipant={onDeleteParticipant}
            participant={participant}
            disableRedirect={disableRedirect}
            disableRemove={disableRemove}
            disableUsers={disableUsers}
            isLoading={isLoading}
            showAssignmentStatus={showAssignmentStatus}
          />
          <ConversationPersonPopoverPaginated
            participant={participant}
            onSelectParticipant={onSelectParticipant}
            onCloseModal={() => setOpen(false)}
            open={open}
            disableUsers={disableUsers}
            participants={participants}
            suggestedParticipants={suggestedParticipants}
          />
        </div>
      </Popover>
    </>
  );
};
